import { createSelector } from 'reselect';

export const getManufacturers = (state) => state.manufacturers.data;
export const getNameIdsMap = (state) => state.manufacturers.namesMap;

export const getManufacturersOptions = createSelector(
  getManufacturers,
  (items) => items.map(({ id: value, name: text }) => ({ value, text })),
);

export const getManufacturersUniqueOptions = createSelector(
  getManufacturersOptions,
  (data) => data.reduce(({ options, namesMap }, option) => {
    if (namesMap[option.text]) {
      return {
        options,
        namesMap: {
          ...namesMap,
          [option.text]: namesMap[option.text].concat([option.value]),
        },
      };
    }

    return {
      options: options.concat([{ ...option }]),
      namesMap: {
        ...namesMap,
        [option.text]: [option.value],
      },
    };
  }, { options: [], namesMap: {} }),
);

export const getManufacturersLabelMap = createSelector(
  getManufacturers,
  (items) => items.reduce((result, { name, id }) => ({ ...result, [id]: name }), {}),
);

export const getManufacturersLoadingState = ({ manufacturers }) => manufacturers.loading;
